import React from "react";
import 'leaflet/dist/leaflet.css';
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <GoogleOAuthProvider clientId={clientId}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </GoogleOAuthProvider>
    </React.StrictMode>
  </Provider>
);
